import axios from "axios";
import { serverURL,headeroption,headeroptionupload } from "../http-common";

class AirconService {
  getallAircon(data) {
    return axios.get(serverURL + "/aircon-api?req=smarttableAircon", {
      params: data,
      headers: headeroption,
    })
  }
  getallAirconjoin(data) {
    return axios.get(serverURL + "/aircon-api?req=smarttablejoinAircon", {
      params: data,
      headers: headeroption,
    })
  }
  
  getAircon(aircon_id) {
    return axios.get(serverURL + "/aircon-api?req=getAircon", {
      params: { aircon_id: aircon_id }, headers: headeroption,
    });
  }
  createAircon(data) {
    return axios.post(serverURL + "/aircon-api?req=createAircon", data, {
      headers: headeroption,
    });
  }
  updateAircon(data) {
    return axios.put(serverURL + "/aircon-api?req=updateAircon", data, {
      headers: headeroption,
    });
  }
  deleteAircon(aircon_id) {
    return axios.delete(serverURL + "/aircon-api?req=deleteAircon", { params: { aircon_id: aircon_id }, headers: headeroption, });
  }
  deleteAll() {
    return axios.delete(serverURL + "/aircon-api?req=deleteAircon");
  }
  findByTitle(aircon_name) {
    return axios.get(serverURL + "/aircon/aircon-api?name=" + aircon_name);
  }
  upload(aircon_id, data) {
    return axios.post(serverURL + "/uploads-api/singlefile?aircon_id=" + aircon_id, data, { headers: headeroptionupload });
  }
  uploads(aircon_id, data) {
    return axios.post(serverURL + "/uploads-api/uploadmultifile?aircon_id=" + aircon_id, data, { headers: headeroptionupload });
  }
}
export default new AirconService();
